import React, {useState} from 'react';
import PropTypes from 'prop-types';

const Tooltip = ({title, description}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="relative inline-block">
      {/* Tooltip Button */}
      <div
        className="cursor-pointer"
        onMouseEnter={() => setShowTooltip(title !== undefined)}
        onMouseLeave={() => setShowTooltip(false)}>
        <svg
          className="w-5 h-5 ml-2.5 mt-0.5 text-gray-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>

        {/* Tooltip Content */}
        {showTooltip && (
          <div className="absolute z-50 min-w-[320px] mt-3 -ml-3">
            {/* Arrow */}
            <div className="relative">
              <div className="absolute -top-2 left-5 w-4 h-4 bg-toolTipBGColor transform rotate-45"></div>
            </div>

            {/* Tooltip Box */}
            <div className="bg-toolTipBGColor text-white rounded-lg p-3 shadow-lg">
              {/* <h3 className="text-md font-medium">{title}</h3> */}
              <p className="text-sm text-white mt-1">{description}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

Tooltip.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

export default Tooltip;
